import { Controller } from "@hotwired/stimulus"
import formDataEntries from "form-data-entries"
import http from "helpers/http"
import debounce from "lodash.debounce"

export default class extends Controller {
  static classes = [ "priceInputAnimation" ]
  static targets = [ "details", "priceInput" ]
  static values = { url: String }

  connect() {
    if (this.hasPriceInputTarget) {
      this.priceInputTarget.addEventListener("animationend", () => this.priceInputTarget.classList.remove(this.priceInputAnimationClass))
    }
  }

  update = debounce( (event) => {
    this.abortPreviousFetchRequest()

    http.get(this.url, { headers: { "X-Requested-With": "XMLHttpRequest" }, signal: this.abortController.signal }).
      text().then(html => {
        this.validate()
        // eslint-disable-next-line no-unsanitized/property -- the response is the details section re-rendered by our own controller
        this.detailsTarget.outerHTML = html
      })
  }, 500)

  selectPlan({ target, params }) {
    const url = new URL(params.url, window.location.href)
    url.searchParams.set("new_plan_id", target.value)

    this.element.closest("turbo-frame").src = url
  }

  // private

  abortPreviousFetchRequest() {
    if(this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
  }

  validate() {
    if (this.hasPriceInputTarget) {
      if(this.minimumPrice && this.price < this.minimumPrice) {
        this.price = this.minimumPrice
        this.animatePriceInput()
      } else if(this.maximumPrice && this.price > this.maximumPrice) {
        this.price = this.minimumPrice
        this.animatePriceInput()
      }
    }
  }

  animatePriceInput() {
    this.priceInputTarget.classList.add(this.priceInputAnimationClass)
    this.priceInputTarget.focus()
  }

  get minimumPrice() {
    return parseFloat(this.priceInputTarget.min)
  }

  get maximumPrice() {
    return Number(this.priceInputTarget.max)
  }

  get price() {
    return Number(this.priceInputTarget.value) || 0
  }

  set price(newValue) {
    this.priceInputTarget.value = newValue
  }

  get url() {
    let url = new URL(this.urlValue)
    formDataEntries(this.element).forEach( ([name, value]) => url.searchParams.set(name, value))
    return url
  }
}
